<template>
  <div>
    <el-divider></el-divider>
    <div class="friendship" v-if="dataList.length > 0" v-loading="loading">
      <span>友情链接：</span>
      <el-link
        class="friendship-link"
        v-for="(friendshipLink, index) in dataList"
        type="info"
        target="_blank"
        :key="index"
        :href="friendshipLink.linkUrl"
      >
        {{ friendshipLink.linkName }}
      </el-link>
    </div>
    <div class="footer-beian">
      Copyright &copy; 2020 <a href="/">{{ title }}</a
      >.保留所有权利
      <a href="http://beian.miit.gov.cn/" target="_blank">
        {{ recordTitle }}
      </a>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'

import { title, recordTitle } from '@/config/setting.config'
import { list } from '@/api/client/friendship'

const loading = ref(true)
const dataList = ref([])

async function getData() {
  loading.value = true
  try {
    const { data } = await list()
    dataList.value = data
  } finally {
    loading.value = false
  }
}

getData()
</script>

<style scoped lang="scss">
.friendship {
  padding-left: 20px;
  font-size: 15px;
  .friendship-link {
    margin: 2px 8px 5px 5px;
    font-size: 14px;
  }
}

.footer-beian {
  text-align: center;
  font-size: 13px;
  color: #a4a4a4;
  padding-bottom: 20px;
}
</style>
